import React from 'react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  // Track when pricing section is viewed
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const baseFeatures = ['6 Tomos PDF completos', 'Bono 1 — Planificador Express', 'Bono 2 — Checklist Pre-Clase Pro', 'Bono 3 — Pack de Frases Pro', 'Acceso inmediato'];
  const completeFeatures = [...baseFeatures, '🔥 S.R.I. Sistema de Retención Infinita', '🔥 Protocolo Estratégico de 12 meses', '🔥 Plan de negocio del instructor autónomo'];
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section id="pricing" data-id="element-237">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-238">
        💰 Elige Tu Pack
      </h2>

      {/* Urgency Block */}
      <div className="bg-gradient-to-r from-orange-500/10 to-red-500/10 border border-orange-500/30 rounded-2xl p-6 max-w-3xl mx-auto mb-12 text-center" data-id="element-239">
        <p className="text-orange-400 font-bold text-lg mb-2" data-id="element-240">
          ⚠️ PRECIO DE LANZAMIENTO
        </p>
        <p className="text-brand-text text-sm md:text-base" data-id="element-241">
          Los 3 bonos son gratuitos solo durante el lanzamiento. El precio
          subirá a 27,99€ sin previo aviso. Aprovecha ahora que sigues a tiempo.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-8" data-id="element-242">
        {/* Base Pack */}
        <div className="bg-gradient-card border border-brand-border rounded-3xl p-8 shadow-card hover:shadow-violet-glow transition-all" data-id="element-243">
          <div className="flex items-center gap-2 mb-4" data-id="element-244">
            <span className="text-3xl" data-id="element-245">🥉</span>
            <div data-id="element-246">
              <h3 className="font-heading text-xl font-bold text-brand-subtitle tracking-wide" data-id="element-247">
                PACK BASE
              </h3>
              <div className="font-heading text-2xl font-black text-brand-title" data-id="element-248">
                13,99€
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-249">
            El sistema completo para empezar a enseñar mejor hoy
          </p>

          <div className="bg-brand-card/50 border border-brand-border/30 rounded-xl p-4 mb-6" data-id="element-250">
            <p className="text-brand-text text-sm italic" data-id="element-251">
              💡 Equivale a menos de lo que cobras por una clase particular,
              pero te da la estructura para toda tu carrera profesional.
            </p>
          </div>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-252">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-253">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-border/50" data-id="element-254">
              <thead data-id="element-255">
                <tr className="border-b border-brand-border/50" data-id="element-256">
                  <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-257">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-258">
                {baseFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-259">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-260">
                      <span className="text-green-400 shrink-0" data-id="element-261">✅</span>
                      <span data-id="element-262">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-263">
            <div className="font-body text-brand-textMuted text-sm mb-1" data-id="element-264">
              Valor real: 83,94€
            </div>
            <div className="font-heading text-4xl font-black text-brand-title mb-4" data-id="element-265">
              13,99€
            </div>
          </div>

          <a href="https://digipromarket.com/cart/56520042512710:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Base', '13.99')} className="font-heading w-full bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-lg py-4 px-6 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-266">
            🚀 ¡QUIERO EL PACK BASE!
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-267">
            <div data-id="element-268">⚡ Acceso Inmediato</div>
            <div data-id="element-269">💳 Pago Único</div>
            <div data-id="element-270">🛡️ Garantía 7 Días</div>
          </div>
        </div>

        {/* Complete Pack */}
        <div className="bg-gradient-card border-2 border-brand-gold rounded-3xl p-8 shadow-gold-glow-lg relative transform md:-translate-y-4" data-id="element-271">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-gold text-brand-bg font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-gold-glow tracking-wider" data-id="element-272">
            ⭐ MÁS POPULAR
          </div>

          <div className="flex items-center gap-2 mb-4" data-id="element-273">
            <span className="text-3xl" data-id="element-274">🥇</span>
            <div data-id="element-275">
              <h3 className="font-heading text-xl font-bold text-brand-subtitle tracking-wide" data-id="element-276">
                PACK COMPLETO
              </h3>
              <div className="font-heading text-2xl font-black text-brand-title" data-id="element-277">
                19,99€
              </div>
            </div>
          </div>

          <p className="font-body text-brand-textMuted mb-6 text-sm" data-id="element-278">
            Todo lo anterior + el Sistema de Retención Infinita S.R.I.
          </p>

          <div className="bg-brand-gold/10 border border-brand-gold/30 rounded-xl p-4 mb-6" data-id="element-279">
            <p className="text-brand-gold text-sm font-semibold mb-2" data-id="element-280">
              ⚠️ NOTA IMPORTANTE:
            </p>
            <p className="text-brand-text text-sm" data-id="element-281">
              El 87% de los propietarios de academia eligen este pack por el
              Sistema de Retención. Evitar que solo 1 alumno se dé de baja ya
              paga este manual 3 veces.
            </p>
          </div>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-282">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-6" data-id="element-283">
            <table className="w-full min-w-[280px] border-collapse bg-brand-card/30 rounded-xl overflow-hidden border border-brand-gold/30" data-id="element-284">
              <thead data-id="element-285">
                <tr className="border-b border-brand-gold/30" data-id="element-286">
                  <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-287">
                    ✅ Incluye
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-288">
                {completeFeatures.map((feature, i) => <tr key={i} className="border-b border-brand-border/30 last:border-0" data-id="element-289">
                    <td className="p-3 font-body text-brand-text text-sm flex items-start gap-2" data-id="element-290">
                      <span className="text-green-400 shrink-0" data-id="element-291">✅</span>
                      <span data-id="element-292">{feature}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center mb-6" data-id="element-293">
            <div className="font-body text-brand-textMuted text-sm mb-1" data-id="element-294">
              Valor real: 140,94€
            </div>
            <div className="font-heading text-4xl font-black text-brand-title mb-4" data-id="element-295">
              19,99€
            </div>
          </div>

          <a href="https://digipromarket.com/cart/56520077934918:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Completo', '19.99')} className="font-heading w-full bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-lg py-4 px-6 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-gold-glow mb-4 tracking-wide" data-id="element-296">
            🚀 ¡QUIERO EL PACK COMPLETO!
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-297">
            <div data-id="element-298">⚡ Acceso Inmediato</div>
            <div data-id="element-299">💳 Pago Único</div>
            <div data-id="element-300">🛡️ Garantía 7 Días</div>
          </div>
        </div>
      </div>

      {/* Guarantee Block */}
      <div className="bg-gradient-card border border-brand-borderGlow/30 rounded-2xl p-8 max-w-3xl mx-auto mb-8 text-center shadow-violet-glow" data-id="element-301">
        <h3 className="text-2xl font-bold text-brand-subtitle mb-4" data-id="element-302">
          🛡️ Compra sin riesgo
        </h3>
        <p className="text-brand-text mb-4 leading-relaxed" data-id="element-303">
          Pruébalo 7 días completos. Si no mejora tu forma de planificar y
          enseñar, te devolvemos cada céntimo. Sin formularios. Sin preguntas.
          Sin drama.
        </p>
        <p className="text-brand-textMuted text-sm" data-id="element-304">
          Más de 300 instructores ya lo usan. Las devoluciones son menos del 1%.
        </p>
      </div>

      <div className="bg-gradient-card border border-brand-borderGlow/20 rounded-2xl p-6 max-w-2xl mx-auto text-center shadow-violet-glow" data-id="element-305">
        <p className="font-body text-brand-subtitle font-medium" data-id="element-306">
          💡 Por solo 6€ más, obtienes el sistema completo de retención y
          escalabilidad. La mayoría elige este.
        </p>
      </div>
    </Section>;
}